/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Copilot_Risk_Actions_DescriptionInputs */



/**
* | output |
* | --- |
* | "Configure what happens when the compliance copilot detects a risk level." |
*
* @param {Compliance_Copilot_Risk_Actions_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_copilot_risk_actions_description = /** @type {((inputs?: Compliance_Copilot_Risk_Actions_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Copilot_Risk_Actions_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konfigurieren Sie, was passiert, wenn der Compliance-Copilot eine Risikostufe erkennt.")
	return /** @type {LocalizedString} */ ("Configure what happens when the compliance copilot detects a risk level.")
});